import { useFetchMeGqlQuery } from '@codegen';
import Intercom, { shutdown, update } from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';

export const useIntercomUpdateProfile = () => {
  const { data } = useFetchMeGqlQuery();
  const { lastName = '', firstName = '' } = data?.me_v2 || {};
  const fullName = `${firstName} ${lastName}`.trim();
  useEffect(() => {
    try {
      if (fullName) {
        update({
          name: fullName,
        });
      }
    } catch (error) {
      console.error('Intercom update profile error', error);
    }
  }, [fullName]);
};

const INTERCOM_OVERRIDE = 'DEBUG_ENABLE_INTERCOM';
const getDebugIntercom = () => {
  return localStorage.getItem(INTERCOM_OVERRIDE)
    ? { hide_default_launcher: false }
    : {};
};
export const bootstrapIntercom = (config: {
  app_id: string;
  user_hash?: string;
  user_id: string;
  email: string;
  name?: string;
  language_override?: string;
}) => {
  // Bootstrap Intercom chat bubble
  Intercom({
    vertical_padding: 80,
    ...config,
    ...getDebugIntercom(),
  });
  return {
    shutdownIntercom: shutdown,
  };
};
